import {
    Message, MessageBox
} from 'element-ui';



//是否 已弹出提示
let isShowMessage = false

export const success = (msg, time) => { //弹出成功提示
    if (isShowMessage)
        return
    isShowMessage = true
    time = typeof time !== 'undefined' ? time : 3;
    Message.info({
        showClose: false,
        message: msg,
        duration: time * 1000,
        iconClass: 'msgicon ',
        customClass: 'iflysseui-msg msg-success',
        offset: 120,
        onClose: () => {
            isShowMessage = false
        }
    });
};

export const error = (msg, time) => { //弹出错误提示
    if (isShowMessage)
        return
    isShowMessage = true
    time = typeof time !== 'undefined' ? time : 3;
    Message.info({
        showClose: false,
        message: msg,
        duration: time * 1000,
        iconClass: 'msgicon',
        customClass: 'iflysseui-msg msg-error',
        offset: 120,
        onClose: () => {
            isShowMessage = false
        }
    });
};

export const diyMsg = (msg, time, iconclass) => {
    if (isShowMessage) {
        return
    }
    isShowMessage = true
    time = typeof time !== 'undefined' ? time : 3;
    Message.info({
        showClose: false,
        message: msg,
        duration: time * 1000,
        iconClass: 'msgicon',
        customClass: 'iflysseui-msg ' + iconclass,
        offset: 120,
        onClose: () => {
            isShowMessage = false
        }
    });
};

export const warning = (msg, time) => { //弹出错误提示
    if (isShowMessage)
        return
    isShowMessage = true
    time = typeof time !== 'undefined' ? time : 3;
    Message.warning({
        showClose: false,
        message: msg,
        duration: time * 1000,
        iconClass: 'msgicon ',
        customClass: 'iflysseui-msg msg-warning',
        offset: 120,
        onClose: () => {
            isShowMessage = false
        }
    });
};

export const confirm = (content, subcontent, title) => { //弹出确认提示
    return window.app.$confirm(`<div class="center" style="height: 390px;width:600px;padding-top:20px"><p style="font-size: 18px;color: #333333;font-weight: bold; line-height: 40px;">${content}</p><p style="color: #969696;">${subcontent}</p></div>`,
        title || '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        dangerouslyUseHTMLString: true,
    });
};

export const important = (content, title, btnTxt) => { //弹出需要确认的提示
    return MessageBox.alert(`<div  style="height: 70px;padding-top:20px">
    <p style="font-size: 16px;color: #333333;font-weight: bold;">${content}</p>
    </div>`,
        title || '提示', {
        confirmButtonText: btnTxt,
        dangerouslyUseHTMLString: true,
        callback: () => {

        }
    });
};

export const manyMsg = (content, title, btnTxt) => { //弹出需要确认的提示
    return MessageBox.alert(`<div class="center"  style="height: 70px;padding-top:20px">
    <p >${content}</p>
    </div>`,
        title || '提示', {
        confirmButtonText: btnTxt,
        dangerouslyUseHTMLString: true,
        callback: () => {

        }
    });
};

export const PromptforConfirm = (content, title, btnTxt, _callback) => { //弹出需要确认的提示
    return MessageBox.alert(`${content}`,
        title || '提示', {
        confirmButtonText: btnTxt,
        dangerouslyUseHTMLString: true,
        callback: () => {
            if (_callback) {
                _callback()
            }

        }
    });
};